import {mapActions, mapGetters} from 'vuex'

export default {
  data () {
    return {
      showQuestModal: false,
      showInfoModal: false,
      showContactModal: false,
      showSearchModal: false,
      env: process.env.NODE_ENV,
      periodFilters: ['daily', 'weekly', 'monthly', 'quarterly', 'yearly', 'once'],
      typeFilters: ['factory', 'sortie', 'exercise', 'expedition', 'supply_repair', 'arsenal', 'refurbishment'],
      limitedFilters: ['permanent', 'limited', 'finished'],
      questSort: 'sortDateDesc',
      sortOptions: [
        { value: 'sortDateDesc', label: '実装日(新しい順)' },
        { value: 'sortDateAsc', label: '実装日(古い順)' }
      ]
    }
  },
  methods: {
    openQuestModal: function () {
      this.showQuestModal = true
    },
    closeQuestModal: function () {
      // 詳細モーダルを閉じる時にURLパラメータを消去
      this.deleteParams('quest_id')
      this.showQuestModal = false
    },
    openInfoModal: function () {
      this.showInfoModal = true
    },
    closeInfoModal: function () {
      this.showInfoModal = false
    },
    openContactModal: function () {
      this.showContactModal = true
    },
    closeContactModal: function () {
      this.showContactModal = false
      this.checkContactCount()
    },
    openSearchModal: function () {
      this.showSearchModal = true
    },
    closeSearchModal: function () {
      this.showSearchModal = false
    },
    resetTypeFilter: function () {
      if (this.typeFilters.length === 7) {
        this.typeFilters = []
      } else {
        this.typeFilters = ['factory', 'sortie', 'exercise', 'expedition', 'supply_repair', 'arsenal', 'refurbishment']
      }
    },
    resetPeriodFilter: function () {
      if (this.periodFilters.length === 6) {
        this.periodFilters = []
      } else {
        this.periodFilters = ['daily', 'weekly', 'monthly', 'quarterly', 'yearly', 'once']
      }
    },
    // 期間限定任務と終了済任務の関係性制御
    controlFinished: function () {
      // 期間限定をoffにする場合は終了済もoffにする
      if (this.limitedFilters.includes('limited') && this.limitedFilters.includes('finished')) {
        const deleteIndex = this.limitedFilters.findIndex((item) => item === 'finished')
        this.limitedFilters.splice(deleteIndex, 1)
      }
    },
    controlLimited: function () {
      // 期間限定がoffの時に終了済をonにする場合は期間限定もonにする
      if (!this.limitedFilters.includes('limited') && !this.limitedFilters.includes('finished')) {
        this.limitedFilters.push('limited')
      }
    },
    // URLパラメータを削除する関数
    deleteParams: function (key) {
      let params = this.$route.params
      delete params[key]
      this.$router.push({params: params})
    },
    // 初期表示の時点でIDが設定されている場合詳細モーダルを開く
    checkQuestId: function () {
      let params = this.$route.params['quest_id']
      if (params !== undefined && params != null) {
        this.setModalQuest(params)
        this.showQuestModal = true
      }
    },
    ...mapActions([
      'fetchQuests',
      'setModalQuest',
      'updatePeriodFilter',
      'updateTypeFilter',
      'updateLimitedFilter',
      'updateQuestSort',
      'checkAppVersion',
      'checkDbVersion',
      'checkContactCount',
      'fetchSearchItemList'
    ]),
    ...mapGetters(['getQuests', 'getModalQuest', 'isNew', 'canContact'])
  },
  watch: {
    periodFilters: function () {
      this.updatePeriodFilter(this.periodFilters)
      this.fetchQuests()
    },
    typeFilters: function () {
      this.updateTypeFilter(this.typeFilters)
      this.fetchQuests()
    },
    limitedFilters: function () {
      this.updateLimitedFilter(this.limitedFilters)
      this.fetchQuests()
    },
    questSort: function () {
      this.updateQuestSort(this.questSort)
      this.fetchQuests()
    }
  },
  mounted () {
    this.checkDbVersion(this.$dbVersion)
    this.checkAppVersion(this.$appVersion)
    this.fetchQuests()
    this.checkContactCount()
    this.checkQuestId()
    this.fetchSearchItemList()
  }
}



// WEBPACK FOOTER //
// ./src/components/manager_main/utils.js